import { MyModal } from '~/components/ui/MyModal'
import {
  follow,
  FollowStatus,
  followVariables,
  getOrderInfo,
  getOrderInfoVariables,
  getOrderInfo_orderModule_copyrightOrder_product,
  RareFlag,
  toPay_orderModule_copyrightPay,
} from '~/graphqls/types'
import { useEffect, useState } from 'react'
import { MyRare } from '~/components/ui/MyRare'
import { MyImage } from '~/components/ui/MyImage'
import { MyBtn } from '~/components/ui/MyBtn'
import Link from 'next/link'
import { useStores } from '~/hooks/useStores'
import { useImperativeQuery } from '~/hooks/useImperativeQuery'
import { FOLLOW, GET_ORDER_INFO } from '~/graphqls/gqls'
import { CreatorAvatar } from '~/components/business/CreatorAvatar'
import FollowBtn from '~/components/business/FollowBtn'
import { useMutation } from '@apollo/client'
import { observer } from 'mobx-react'

export const MysteryBoxModal: React.FC<{
  payInfo: toPay_orderModule_copyrightPay | undefined
}> = observer(({ payInfo }) => {
  const [open, setOpen] = useState(false)
  const [mounted, setMounted] = useState(false)

  const { store } = useStores()
  const [productData, setProductData] =
    useState<getOrderInfo_orderModule_copyrightOrder_product>()

  const isSelf = store.userinfo?.base?.uid === productData?.creator?.id

  const getOrderInfoQuery = useImperativeQuery<
    getOrderInfo,
    getOrderInfoVariables
  >(GET_ORDER_INFO)

  const [followAction] = useMutation<follow, followVariables>(FOLLOW)

  useEffect(() => {
    if (!mounted) {
      getOrderInfoQuery({
        orderNo: payInfo?.orderNo,
      }).then(data => {
        setProductData(
          data?.data?.orderModule?.copyrightOrder
            ?.product as getOrderInfo_orderModule_copyrightOrder_product
        )

        if (
          store.userinfo?.base?.uid !==
          data?.data?.orderModule?.copyrightOrder?.product?.creator?.id
        ) {
          followAction({
            variables: {
              param: {
                followUid:
                  data.data.orderModule?.copyrightOrder?.product?.creator?.id,
              },
            },
          })
        }

        setMounted(true)

        setTimeout(() => {
          setOpen(true)
        }, 3000)
      })
    }
  }, [getOrderInfoQuery, payInfo, mounted])

  return (
    <>
      {mounted && (
        <MyModal
          visible={store.modal?.mysteryBox}
          closable={false}
          maskStyle={{
            backgroundColor: 'rgba(0,0,0,0.8)',
          }}
          bodyStyle={{
            padding: 16,
            textAlign: 'center',
          }}
          width={270}
          footer={null}
        >
          {open && (
            <div className="relative">
              <img
                className="absolute w-full top-4 left-0 right-0 m-auto z-10"
                src="/images/mystery-box/cheer.png"
                alt=""
              />
              <div className="text-lg neutral-200 mb-2 font-semibold">
                恭喜获得
              </div>
              <div className="text-sm neutral-200 mb-2">
                {productData?.name}{' '}
                <MyRare rare={productData?.rareFlag as RareFlag} />
              </div>
              <MyImage
                className="w-[238px] h-[238px] object-cover rounded-2xl mb-2"
                lazy={false}
                tag="v800"
                src={productData?.artworkUrl}
              />

              {!isSelf && (
                <div className="bg-neutral-700 rounded-xl p-3 mb-4 flex justify-between items-center">
                  <div className="flex items-center">
                    <CreatorAvatar
                      image={productData?.creator?.avatar as string}
                      iconClassName="h-3 -right-[3px] max-w-[18px]"
                      userRole={productData?.creator?.userRoleInfo}
                      size={32}
                    ></CreatorAvatar>
                    <div className="text-xs text-neutral-200 ml-2 text-overflow w-[80px]">
                      {productData?.creator?.name}
                    </div>
                  </div>
                  <FollowBtn
                    status={FollowStatus.ME_ONE_WAY}
                    targetId={productData?.creator?.id}
                  />
                </div>
              )}

              <div className="flex justify-between">
                <MyBtn
                  style={{ width: 112 }}
                  onClick={() => {
                    location.reload()
                    store.modal?.setMysteryBoxVisible(false)
                  }}
                >
                  取消
                </MyBtn>
                <MyBtn style={{ width: 112 }} type="primary">
                  <Link href={`/product/${productData?.id}`}>
                    <a>去查看</a>
                  </Link>
                </MyBtn>
              </div>
            </div>
          )}
          {!open && (
            <>
              <div className="text-base mb-2 neutral-200">盲盒开启中</div>
              <img src="/images/mystery-box/open.png" alt="" />
            </>
          )}
        </MyModal>
      )}
    </>
  )
})
